import app from "../_app";
import axios from "axios";
import {quantityControlInit} from "./quantityControl";
import {loader} from './loader.js';

const microcart = document.querySelector('.js-added-to-cart');
export const toggleAddedToCart = async (refresh) => {

    const microcartProducts = microcart.querySelector('.js-microcart-products');
    microcartProducts.innerHTML = loader();

    let response = await axios.get(`${Shopify.routes.root}cart.js`);

    const microcartEmpty = microcart.dataset.empty;

    const microcartTotal = microcart.querySelector('.js-added-to-cart-total');
    const microcartSubtotal = microcart.querySelector('.js-added-to-cart-subtotal');
    const shipping = microcart.querySelector('.js-cart-shipping');
    const microcartProgressWrapper = microcart.querySelector('.js-added-to-cart-progress');
    const microcartProgress = microcart.querySelector('.js-added-to-cart-progressbar');
    const microcartProgressText = microcart.querySelector('.js-added-to-cart-progress-text');
    const microcartProgressDone = microcart.querySelector('.js-added-to-cart-progress-done');
    const microcartProgressRemaing = microcart.querySelector('.js-microcart-remaining');


    if (microcartTotal) {
        microcartTotal.innerHTML = '';
    }

    if (response.status === 200) {
        let data = response.data;

        if (data.items.length == 0) {
            microcartProducts.innerHTML = microcartEmpty;
        } else {
            microcart.removeAttribute('data-empty');

            microcartProducts.classList.remove('text-center');

            microcartProducts.innerHTML = data.items.map((item, index) => {

                let optionsHTML = '';
                const optionName = item.options_with_values[0].name;
                if (item.options_with_values &&
                    item.options_with_values.length > 0 &&
                    optionName !== 'Title' &&
                    optionName !== 'Titel' &&
                    optionName !== 'Titre'
                ) {
                    optionsHTML = item.options_with_values.map(option => `<span class="fs-300 c--gray me-1">${option.name}:</span><span class="fs-300">${option.value}</span>`).join('');
                }
                const image = item.image ? `<img src="${item.image}&height=75" alt="${item.title}" loading="lazy">` : '';

                return `
                    <div class="microcart-product js-cart-item">
                      <div class="row mx-n2 py-2">
                        <div class="col-auto px-2 d-flex align-items-center">
                          <a href="${item.url}" class="microcart-product__image-wrapper ">
                            <picture class="microcart-product__image img img--t text-center">
                              ${image}
                            </picture>
                          </a>
                        </div>
                        <div class="col px-2">
                          <div class="microcart-product__content mr-lg-3 pt-lg-1 pb-1">
                            <div class="row no-gutters">
                              <div class="col">
                                <a href="${item.url}">
                                  <h3 class="heading heading--sm fs-300 fs-lg-300 mb-2">${item.product_title}</h3>
                                  ${optionsHTML}
                                  <span class="c--g"></span>
                                </a>
                              </div>
                              <div class="col-auto">
                                <div class="price">
                                  <span class="fs-300 fw-700">${app.currency(item.price)}</span>
                                </div>
                              </div>
                            </div>
                            
                            <div>
                            <div class="row no-gutters align-items-center align-self-end js-quantity">
                              <div class="col-6">
                                <div class="microcart-product__quantity">
                                    <div class="js-quantity-control number">
                                        <button class="number__plus js-quantity-control-plus" type="button">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                                                <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/>
                                            </svg>
                                        </button>
                                        
                                        <button class="number__minus js-quantity-control-min" type="button">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                                                <path d="M200-440v-80h560v80H200Z"/>
                                            </svg>
                                        </button>
                    
                                        <input name="updates[]" id="updates_${item.key}" value="${item.quantity}" class="js-quantity-control-input"
                                               type="number" min="0" max="${item.quantity_rule.max}" step="1" pattern="[0-9]*" data-key="${item.key}">
                                    </div>
                                </div>
                              </div>
     
                              <div class="product__error-message c--orange fs-200 js-addtocart-error"></div>
                            </div>
                                
                            </div>
                              <div class="product__error-message c--orange fs-200 js-addtocart-error"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
            }).join('').replace(/\n\s+/g, '');

            let extraCosts = 0;

            if (shipping) {
                if (data.total_price < +shipping.dataset.threshold) {
                    extraCosts += +shipping.dataset.costs;
                    shipping.removeAttribute('data-above');
                } else {
                    shipping.setAttribute('data-above', '');
                }
            }

            let progress = (data.total_price / microcartProgress.dataset.threshold) * 100;
            console.log(progress);
            let remainingPrice = (parseInt(microcartProgress.dataset.threshold) - data.total_price) / 100;

            microcartProgressRemaing.innerHTML = '€' + remainingPrice.toFixed(2).replace('.', ',').replace(',00', '');

            if (progress >= 100) {
                progress = 100;
                microcartProgressText.classList.add('d-none');
                microcartProgressDone.classList.remove('d-none');

            } else {
                microcartProgressText.classList.remove('d-none');
                microcartProgressDone.classList.add('d-none');
            }
            microcartProgress.style.width = progress + '%';

            if (microcartTotal) {
                microcartTotal.innerHTML = app.currency(data.total_price + extraCosts);
            }

            if (data.item_count === 0) {
                microcart.setAttribute('data-empty', '');
                microcartProgressWrapper.classList.add('d-none');
                microcartProgressWrapper.classList.add('no-border');
            } else {
                microcartProgressWrapper.classList.remove('d-none');
                microcartProgressWrapper.classList.remove('no-border');
            }

            const quantities = [...document.querySelectorAll(".js-quantity-control")];
            quantities.map(quantityControlInit);
        }
    }

}

export const updateCartCount = async () => {
    const $cartCount = [...document.querySelectorAll('.js-cart-count')];
    const cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json());
    $cartCount.map(cartCount => {
        cartCount.innerText = cartData.item_count;
    });
}

if (microcart) {
    const triggers = [...document.querySelectorAll('.js-popup-trigger[data-key="cart.added-to-cart"]')];
    //document.querySelector('.js-added-to-cart-products').innerHTML = loader();
    triggers.map(trigger => trigger.addEventListener('click', toggleAddedToCart));
}
